import React from "react";
import {useDispatch, useSelector} from "react-redux"
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { logoutUser, setUserInfo } from "../../redux/slice/user";
import { Button, Grid, Paper } from "@mui/material"
import { FileUploadButton } from "../component/common/fileupload/FileUpload";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import SamplePage from "../sample/SamplePage";
import DownloadIcon from '@mui/icons-material/Download';
// import SampleUploadPage from "./SampleUploadPage_2";
// import SampleUploadPage from "./SampleUploadPage_3";

// import SampleUploadPage from "./Sample_ref";
import api from "../../API";

const LandingPage = () => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const userinfo = useSelector((state:any) => state.userInfo.data)

  // console.log('userinfo',userinfo)

  const downloadMenual = async (filename:string) => {
    await api.get("/downloadMenual?filename="+filename,{ responseType: 'blob' })
    .then((res:any) => {
      console.log('메뉴얼 다운') 
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e) => {if(e.response.status == 400) alert("서버오류입니다. ")})
  }

  const logout = async () => {
    //로그아웃
    dispatch(logoutUser())
    nav("/");
  };

  return (
    // (userinfo.user.roles.length > 0) ? (
    //   <SampleUploadPage />
    // ) : 
    // (
      <Box sx={{ width: "100%"}}>
        <Grid container>
          <img style={{width:"100%"}} src={process.env.PUBLIC_URL + "/img/main_img.png"} />
          <Box sx={{display:"flex", width:"100%"}}>
            {/* <Grid item xs={6}>
              <Box m={4}>
                <Paper elevation={3} sx={{margin:'auto', padding: "8px", backgroundColor:"#eee"}}>
                  <Box sx={{fontWeight:700, fontSize:"16px", marginLeft:"24px"}}>
                    <img style={{width: "118px"}} src={process.env.PUBLIC_URL + "/img/gongi_title.png"} />
                  </Box>
                  <Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableBody>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>[10.다양한소음원에서의Ground Truth지식정보데이터] 크라우드워커 모집</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>2023/06/30</Box>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>음성(대화) 녹음 매뉴얼이 업데이트(v1.2) 되었습니다.</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>2023/07/20</Box>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>크라우드 워커 급여 지급 방식 안내</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>2023/07/01</Box>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>[10.다양한소음원에서의Ground Truth지식정보데이터] 크라우드워커 모집</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>2023/06/30</Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Paper>
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              <Box m={4}>
              <Paper elevation={3} sx={{margin:'auto', padding: "8px"}}>
                  <Box sx={{fontWeight:800, fontSize:"20px", marginLeft:"24px"}}>
                    매뉴얼
                  </Box>
                  <Box>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableBody>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } , cursor:"pointer"}} onClick={()=>downloadMenual('20230831_데이터수집플랫폼_클로바노트_사용법_인사이트정보_2차_CW용_v1.0.pdf')} >
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>20230831_데이터수집플랫폼_클로바노트_사용법_인사이트정보_2차_CW용_v1.0</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}><DownloadIcon fontSize="large" sx={{verticalAlign: "middle", color:"#7787cf"}} /></Box>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } , cursor:"pointer"}} onClick={()=>downloadMenual('20230831_음성녹음_상세절차안내_인사인트정보_2차_CW용_v1.0.pdf')}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>20230831_음성녹음_상세절차안내_인사인트정보_2차_CW용_v1.0</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                          <Box sx={{fontWeight:700, fontSize:"17px"}}><DownloadIcon fontSize="large" sx={{verticalAlign: "middle", color:"#7787cf"}}  /></Box>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } , cursor:"pointer"}} onClick={()=>downloadMenual('20230831_음성녹음매뉴얼_요약본_인사이트정보_2차_CW용_2p_v1.0.pdf')}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>20230831_음성녹음매뉴얼_요약본_인사이트정보_2차_CW용_2p_v1.0</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                          <Box sx={{fontWeight:700, fontSize:"17px"}}><DownloadIcon fontSize="large" sx={{verticalAlign: "middle", color:"#7787cf"}}  /></Box>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } , cursor:"pointer"}} onClick={()=>downloadMenual('20230831_음성녹음매뉴얼_인사이트정보_2차_CW용_2p_v1.0.pdf')}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>20230831_음성녹음매뉴얼_인사이트정보_2차_CW용_2p_v1.0</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                          <Box sx={{fontWeight:700, fontSize:"17px"}}><DownloadIcon fontSize="large" sx={{verticalAlign: "middle", color:"#7787cf"}}  /></Box>
                          </TableCell>
                        </TableRow>
                        {/* <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell component="th" scope="row" align="left">
                            <Box sx={{fontWeight:700, fontSize:"17px"}}>[08.한국어 SNS 멀티턴 대화 데이터] SNS 멀티턴 작성 매뉴얼</Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                          <Box sx={{fontWeight:700, fontSize:"17px"}}><DownloadIcon fontSize="large" sx={{verticalAlign: "middle", color:"#7787cf"}} /></Box>
                          </TableCell>
                        </TableRow> */}
                      </TableBody>
                    </Table>
                    {/* <h3>ID : {userinfo.user.id}</h3>
                    <h3>Email : {userinfo.user.email}</h3>
                    <button onClick={logout}>Logout</button>
                    <button onClick={()=>nav('/insight/main')}>main</button>
                    <button onClick={me}>meme</button> */}
                    {/* <FileUploadButton/> */}
                  </Box>
                </Paper>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Box>
  //     )
  );
};

export default LandingPage;
